import { pascalCase } from '@takeshape/util';
import { INDEXED_QUERY_NAME_PREFIX, LIST_QUERY_NAME_SUFFIX, RELATED_QUERY_NAME_PREFIX } from './constants';

export function isGeneratedQueryName(name: string) {
  if (name.endsWith(LIST_QUERY_NAME_SUFFIX)) {
    return name.startsWith(INDEXED_QUERY_NAME_PREFIX) || name.startsWith(RELATED_QUERY_NAME_PREFIX);
  }

  return false;
}

export function getIndexedListQueryName(name: string | string[]): string {
  return `${INDEXED_QUERY_NAME_PREFIX}${pascalCase(name)}${LIST_QUERY_NAME_SUFFIX}`;
}

export function getRelatedListQueryName(name: string | string[]): string {
  return `${RELATED_QUERY_NAME_PREFIX}${pascalCase(name)}${LIST_QUERY_NAME_SUFFIX}`;
}
